import { Box, Container, Heading, Stack, Text, Input, Textarea, Button, VStack, HStack, Spinner } from '@chakra-ui/react';
import React, { useState, useEffect } from 'react';
import { GET } from '../utilities/ApiProvider';
import { baseUrl } from '../utilities/customUrls';

export default function Contact() {
  const contactInfo = [
    {
      heading: 'Pakistan Address',
      email: 'info@mujaddidalifsani.com',
      cell: '+92 300 2230155',
      visitUs: 'House No 83, Sector 4F, Mujahid Colony, Orangi Town, S.I.T.E, Karachi',
      iconType: 'address'
    }
  ];

  const [isLoading, setIsLoading] = useState(false);
  const [bankDetails, setBankDetails] = useState([]);

  useEffect(() => {
    fetchBankDetails();
  }, []);

  const fetchBankDetails = async () => {
    setIsLoading(true);
    try {
      let response = await GET(`${baseUrl}/BeneficiaryAccount`, {
        authorization: `Basic ${btoa('admin:admin123')}`
      });
      console.log('Bank Details Response:', response);
      if (response?.Data && response.Data.length > 0) {
        setBankDetails(new Array(response.Data[0]));
      } else {
        console.log('No bank data received');
        setBankDetails([]);
      }
    } catch (error) {
      console.error('Error fetching bank details:', error);
      setBankDetails([]);
    }
    setIsLoading(false);
  };
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async () => {
    if (!formData.name || !formData.email || !formData.subject || !formData.message) {
      setSubmitStatus({ type: 'error', message: 'Please fill in all fields.' });
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      // Using EmailJS - sign up free at emailjs.com and get your service ID and template ID
      const response = await fetch('https://api.emailjs.com/api/v1.0/email/send', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          service_id: 'service_4rbi4xm',
          template_id: 'template_g4ljgxn',
          user_id: '1x0kO0wrmLkLmpvQS',
          template_params: {
            from_name: formData.name,
            from_email: formData.email,
            subject: formData.subject,
            message: formData.message,
            to_email: 'info@mujaddidalifsani.com'
          }
        })
      });

      if (response.ok) {
        setSubmitStatus({ type: 'success', message: 'Message sent successfully!' });
        setFormData({ name: '', email: '', subject: '', message: '' });
      } else {
        setSubmitStatus({ type: 'error', message: 'Failed to send message. Please try again.' });
      }
    } catch (error) {
      setSubmitStatus({ type: 'error', message: 'Error sending message. Please try again.' });
      console.error('Error:', error);
    }
    setIsSubmitting(false);
  };

  return (
    <Box bg="white" py={{ base: 10, md: 20 }}>
      <Container maxW="7xl">
        {/* Header */}
        <VStack spacing={6} mb={16} textAlign="center">
          <Heading as="h1" size="2xl" color="#233F4D" fontWeight="bold">
            Get in Touch
          </Heading>
          <Text fontSize="16px" color="#748188" maxW="3xl">
            For further queries and information, feel free to contact us. You can also contact us for knowing about our donation process and upcoming events.
          </Text>
        </VStack>

        {/* Main Content */}
        <HStack
          spacing={{ base: 0, md: 12 }}
          alignItems="flex-start"
          flexDirection={{ base: 'column', md: 'row' }}
        >
          {/* Form Section */}
          <Box flex={1} w={{ base: '100%', md: 'auto' }}>
            <VStack spacing={6}>
              <Textarea
                name="message"
                placeholder="Enter Message"
                value={formData.message}
                onChange={handleInputChange}
                minH="160px"
                borderColor="#E2E8F0"
                _focus={{
                  borderColor: '#233F4D',
                  boxShadow: 'none'
                }}
                fontSize="14px"
              />

              <HStack spacing={4} w="100%">
                <Input
                  name="name"
                  placeholder="Enter your name"
                  value={formData.name}
                  onChange={handleInputChange}
                  borderColor="#E2E8F0"
                  _focus={{
                    borderColor: '#233F4D',
                    boxShadow: 'none'
                  }}
                  fontSize="14px"
                />
                <Input
                  name="email"
                  type="email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleInputChange}
                  borderColor="#E2E8F0"
                  _focus={{
                    borderColor: '#233F4D',
                    boxShadow: 'none'
                  }}
                  fontSize="14px"
                />
              </HStack>

              <Input
                name="subject"
                placeholder="Enter Subject"
                value={formData.subject}
                onChange={handleInputChange}
                borderColor="#E2E8F0"
                _focus={{
                  borderColor: '#233F4D',
                  boxShadow: 'none'
                }}
                fontSize="14px"
              />

              {submitStatus && (
                <Box
                  w="100%"
                  p={3}
                  borderRadius="md"
                  bg={submitStatus.type === 'success' ? '#C6F6D5' : '#FED7D7'}
                  color={submitStatus.type === 'success' ? '#22543D' : '#742A2A'}
                  fontSize="14px"
                >
                  {submitStatus.message}
                </Box>
              )}

              <Button
                onClick={handleSubmit}
                isLoading={isSubmitting}
                loadingText="SENDING..."
                bg="#20C997"
                color="white"
                border="2px solid #20C997"
                _hover={{
                  bg: '#1BA883',
                  borderColor: '#1BA883'
                }}
                px={12}
                py={6}
                fontWeight="bold"
                fontSize="14px"
                letterSpacing="1px"
                alignSelf="flex-start"
              >
                SEND
              </Button>
            </VStack>
          </Box>

          {/* Contact Info Section */}
          <Box flex={1} w={{ base: '100%', md: 'auto' }}>
            <VStack spacing={12} alignItems="flex-start">
              {/* Address Card */}
              {contactInfo.map((info, i) => (
                <Box key={i} w="100%">
                  <HStack spacing={6} alignItems="flex-start">
                    <Box
                      w="48px"
                      h="48px"
                      flexShrink={0}
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <img 
                        src="/src/assets/images/icons/address.png"
                        alt="Address Icon"
                        style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                      />
                    </Box>

                    <VStack spacing={2} alignItems="flex-start">
                      <Heading fontSize="18px" color="#233F4D" fontWeight="bold">
                        {info.heading}
                      </Heading>
                      <Text fontSize="14px" color="#748188">
                        {info.visitUs}
                      </Text>
                    </VStack>
                  </HStack>
                </Box>
              ))}

              {/* Phone Card */}
              <Box w="100%">
                <HStack spacing={6} alignItems="flex-start">
                  <Box
                    w="48px"
                    h="48px"
                    flexShrink={0}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <img 
                      src="/src/assets/images/icons/call.png"
                      alt="Phone Icon"
                      style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                    />
                  </Box>

                  <VStack spacing={1} alignItems="flex-start">
                    <Heading fontSize="18px" color="#233F4D" fontWeight="bold">
                      +92 300 2230155
                    </Heading>
                    <Text fontSize="14px" color="#748188">
                      Mon to Fri 9am to 6pm
                    </Text>
                  </VStack>
                </HStack>
              </Box>

              {/* Email Card */}
              <Box w="100%">
                <HStack spacing={6} alignItems="flex-start">
                  <Box
                    w="48px"
                    h="48px"
                    flexShrink={0}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <img 
                      src="/src/assets/images/icons/mail.png"
                      alt="Email Icon"
                      style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                    />
                  </Box>

                  <VStack spacing={1} alignItems="flex-start">
                    <Heading fontSize="18px" color="#233F4D" fontWeight="bold">
                      info@mujaddidalifsani.com
                    </Heading>
                    <Text fontSize="14px" color="#748188">
                      Send us your query anytime!
                    </Text>
                  </VStack>
                </HStack>
              </Box>
            </VStack>
          </Box>
        </HStack>
      </Container>
    </Box>
  );
}